import React from "react";

import { classNames } from "@greeter/util";

import css from "./Container.module.scss";

export type ContainerProps = React.PropsWithChildren & {
  className?: string;
  style?: React.CSSProperties;
} & React.ComponentProps<"div">;

export function Container({ className, ...props }: ContainerProps) {
  return <div {...classNames(css.Container, className)} {...props} />;
}

export type PageContainerProps = ContainerProps;

export function PageContainer({ className, ...props }: PageContainerProps) {
  return <Container {...classNames(css.PageContainer, className)} {...props} />;
}
